export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9161.672b946f.jpg";